import React from "react";
import { useSelector } from "react-redux";

const Ad = React.memo(({ name }) => {
  const { AdData } = useSelector((state) => state.customAds);

  const adItem = AdData.find((item) => item.attributes.name === name);

  if (!adItem) {
    return null;
  }

  const imageUrl = adItem.attributes.image.data.attributes.formats?.medium?.url
    ? `${process.env.REACT_APP_UPLOAD_URL}${adItem.attributes.image.data.attributes.formats.medium.url}`
    : `${process.env.REACT_APP_UPLOAD_URL}${adItem.attributes.image.data.attributes.url}`;

  return (
    <div>
      <a href={adItem.attributes.url} target="_blank" rel="noopener noreferrer">
        <img
          src={imageUrl}
          loading="lazy"
          alt={adItem.attributes.name}
          className="object-cover h-full w-full"
        />
      </a>
    </div>
  );
});

export default Ad;
